import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "school-group-container" }
const _hoisted_2 = { class: "form-card-tabs-container px-44" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = { class: "text-[#4B5563] text-2xl font-normal border-b-[1px] border-[#D0D5DD] pb-3" }
const _hoisted_5 = { class: "columns-2 mt-6" }
const _hoisted_6 = { class: "text-dark-grey font-medium text-2xl my-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_12 = {
  key: 0,
  class: "relative top-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "flex-shrink-0" }
const _hoisted_16 = { class: "ml-3" }
const _hoisted_17 = { class: "ml-auto pl-3" }
const _hoisted_18 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_19 = { class: "sr-only" }
const _hoisted_20 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex justify-between items-center mt-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_24 = { class: "font-semibold text-sm color-[#475467]" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "font-semibold text-sm" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 3,
  class: "rounded-md bg-green-50 p-4 mt-5"
}
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "flex-shrink-0" }
const _hoisted_32 = { class: "ml-3" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "ml-auto pl-3" }
const _hoisted_35 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_36 = { class: "sr-only" }
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_39 = { class: "bg-[#FDA29B] rounded-full p-3 text-white" }
const _hoisted_40 = { class: "mt-5 text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_43 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_44 = { class: "flex flex-row items-center justify-center w-full" }
const _hoisted_45 = {
  key: 0,
  class: "ml-2"
}

import { Admin } from '@/interfaces/admin.interface';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { FormKitNode } from '@formkit/core';
import { useSchoolGroupStore } from '@/stores/schoolGroupsStore';
import { useAdminStore } from '@/stores/adminStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { useFilterStore } from '@/stores/filterStore';
import { TrashIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import i18n from '@/plugins/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSchoolGroupComponent',
  emits: ["updateValue"],
  setup(__props, { emit: emits }) {

const schoolStore = useSchoolStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const schoolGroupStore = useSchoolGroupStore();

const schoolGroup = ref({
    name: "",
    description: ""
});

const originalSchoolGroup = ref({
  name: "",
  description: ""
});


const newSchoolGroupAdmins = ref<Admin[]>([]);
const buttonIsDisabled = ref(false); 
const updateSuccess = ref(false);
const responseMessage = ref("");
const newSchoolGroupAdmin = ref({
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Group Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  schoolGroup: "",
}) as any;
/**
 * Champion Delete Functions & Refs
 */
 const confirmChampionDeletionModal = ref(false);
const adminToDelete = ref<Admin | null>(null);
const deleteChampSuccess = ref(false);
const showChampionDeleteNotification = ref(false);




const previewStep = () => {
    emits("updateValue", false);
};
const closeSuccess = () => {
  updateSuccess.value = false;
  responseMessage.value = "";
};

const hasChanges = computed(() => {
  return JSON.stringify(schoolGroup.value) !== JSON.stringify(originalSchoolGroup.value);
});

const isButtonDisabled = computed(() => {
  return (
    adminStore.loader.creatingAdmin ||
    schoolStore.updateLoader ||
    newSchoolGroupAdmins.value.length === 0 ||
    buttonIsDisabled.value
  );
});

const changedFields = computed(() => {
  const updatedFields: any = {};

  if (schoolGroup.value.name !== originalSchoolGroup.value.name) {
    updatedFields.name = schoolGroup.value.name;
  }

  if (schoolGroup.value.description !== originalSchoolGroup.value.description) {
    updatedFields.description = schoolGroup.value.description;
  }

  return updatedFields;
});

const saveChanges = async () => {
    let schoolGroupChampionsCount = 0;
    //clear message and visibility
    responseMessage.value = "";
    updateSuccess.value = false;

    if (newSchoolGroupAdmins.value.length > 0) {
        for (const admin of newSchoolGroupAdmins.value) {
            // Check if all necessary fields are filled
            if (admin.firstName && admin.lastName && admin.email) {
                // Validate email format
                if (!admin.email) {
                    console.error(`Invalid email format: ${admin.email}`);
                    // Skip this admin if the email is invalid
                    continue; 
                }

                // Add school group key to admin
                admin.schoolGroup = filterStore.selectedFilters.schoolGroup as string;

                // Create a new school group admin
                const res = await schoolGroupStore.createNewAdmin(admin);

                if (res) {
                    // Add champion to state
                    schoolGroupStore.addSchoolGroupChampion(res);

                    // Increment counter for successful admin creation
                    schoolGroupChampionsCount++;
                } else {
                    console.error(`Failed to create admin: ${JSON.stringify(admin)}`);
                }
            } else {
                console.log("School group champion data is incomplete:", admin);
            }
        }
    }

    if (hasChanges.value) {

        const schoolGroupId = filterStore.selectedFilters.schoolGroup;
        const response = await schoolGroupStore.updateSchoolGroup(schoolGroupId, changedFields.value);

        if (response) {

            console.log("School group updated successfully:", response);
            filterStore.updateSchoolGroup(response);

            // Update the original reference to prevent duplicate changes
            originalSchoolGroup.value = { ...schoolGroup.value };

            // Show success message (optional)
            responseMessage.value = i18n.global
            .t("internal_tools.success.school_group_update")
            .toString();
            updateSuccess.value = true;
        }
    }

    // Display success message only if champions were created
    if (schoolGroupChampionsCount > 0) {
        responseMessage.value += "<br/>" + i18n.global
            .t("internal_tools.success.champions_message")
            .toString();
        updateSuccess.value = true;

        console.log(`${schoolGroupChampionsCount} school group champion(s) successfully created.`);
    } else {
        console.log("No school group champions were created.");
    }

    if (updateSuccess.value) {
        // Fetch the updated school group details
        getSchoolGroupDetails();
    }
  
    // Clear the form regardless of the result
    clearData();

};

const removeSchoolGroupChampion = (index: number) => {
  newSchoolGroupAdmins.value.splice(index, 1);
};

const addSchoolGroupChampion = () => {
  // Spread newAdmin to create a new instance and generate a unique _id
  newSchoolGroupAdmins.value.push({
    ...newSchoolGroupAdmin.value,
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
  });
}; 

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

const getSchoolGroupDetails = async () => {
  console.log("Fetching school group details...");

  const schoolGroupId = filterStore.selectedFilters.schoolGroup;
  await schoolGroupStore.fetchSchooGroupById(schoolGroupId);

  if (schoolGroupId) {
    const group = schoolGroupStore.schoolGroups.find(g => g._id === schoolGroupId);
    
    if (group) {
      schoolGroup.value.name = group.name;
      schoolGroup.value.description = group.description;

      // Store original values for tracking changes
      originalSchoolGroup.value.name = group.name;
      originalSchoolGroup.value.description = group.description;
    }
  }

//   // Clear the newSchoolGroupAdmins array
//   newSchoolGroupAdmins.value = [];
};

const clearData = () => {
    // Clear the newSchoolGroupAdmins array
    newSchoolGroupAdmins.value = [];
};

onBeforeMount(async () => {
// school grooup details
getSchoolGroupDetails();
});

// Watcher to detect changes
watch(
  () => schoolGroup.value,
  (newVal, oldVal) => {
    console.log("School Group Changed:", newVal);
    updateSuccess.value = false;
  },
  { deep: true }
);

watch(() => filterStore.selectedFilters.schoolGroup, getSchoolGroupDetails);

const showConfirmChampionDeletionModal = (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  
  confirmChampionDeletionModal.value = true;
  adminToDelete.value = admin;
};

const canceldeletion = () => {
  confirmChampionDeletionModal.value = false;
};

const removeExistingChampion = async (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  deleteChampSuccess.value = false;

  // get the selected champion's id
  const championId = admin._id;

  //  use new action to delete the champion
  if (championId) {
    const deletedChampion = await adminStore.deleteExistingChampion(championId, filterStore.selectedFilters.schoolGroup, "school-group");
    deleteChampSuccess.value = deletedChampion;
    showChampionDeleteNotification.value = deletedChampion;
  } else {
    console.error("Champion ID is undefined");
    deleteChampSuccess.value = false;
  }

  confirmChampionDeletionModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (previewStep())),
          type: "submit",
          class: "font-semibold text-[#344054] my-4 text-base border-[#D0D5DD] border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
        ]),
        _createVNode(_component_FormKit, {
          type: "form",
          id: "school-group",
          class: "group-details-form",
          actions: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('internal_tools.school_group.group_details')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.school_group.group_name'),
                "outer-class": "primary-select primary-select-clear formkit-messages-edit",
                "inner-class": "bg-white",
                placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                modelValue: schoolGroup.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schoolGroup.value.name) = $event)),
                validation: "required",
                "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_name_validation')
                        }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.school_group.group_description'),
                "outer-class": "primary-select primary-select-clear formkit-messages-edit",
                "inner-class": "bg-white",
                placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                modelValue: schoolGroup.value.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schoolGroup.value.description) = $event)),
                validation: "required",
                "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_description_validation')
                        }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("internal_tools.single_school_component.title")), 1),
        _hoisted_7,
        (_unref(schoolGroupStore).schoolGroupByIdLoader === true || _unref(schoolGroupStore).loader.creatingAdmin == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(schoolGroupStore)?.activeSchoolGroup?.schoolGroupChampions, (admin) => {
              return (_openBlock(), _createElementBlock("div", {
                key: admin._id,
                class: "columns-5 mt-4 mb-2 relative"
              }, [
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_name'),
                  "outer-class": "primary-select",
                  placeholder: _ctx.$t('internal_tools.form.champion_name'),
                  modelValue: admin.firstName,
                  "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_surname'),
                  "outer-class": "primary-select",
                  placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                  modelValue: admin.lastName,
                  "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "email",
                  label: _ctx.$t('internal_tools.form.champion_email'),
                  "outer-class": "primary-select",
                  placeholder: _ctx.$t('internal_tools.form.champion_email'),
                  modelValue: admin.email,
                  "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  validation: "required|email|(500)email_exists",
                  "validation-rules": { email_exists: email_exists },
                  "validation-messages": {
                    email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                    ),
                    email: _ctx.$t(
                    'add_grades_class_component.step_1.invalid_email'
                    )
                },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_title'),
                  "outer-class": "primary-select",
                  placeholder: _ctx.$t('internal_tools.form.champion_title'),
                  disabled: "true",
                  style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                  modelValue: admin.designation,
                  "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "number",
                  label: _ctx.$t('internal_tools.form.champion_phone'),
                  "outer-class": "primary-select",
                  placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                  modelValue: admin.phoneNumber,
                  "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event),
                  disabled: "true"
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  (_unref(adminStore).loader.deleteAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_spinner_loader)
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (showConfirmChampionDeletionModal(admin, $event)),
                        class: "mt-2 text-red-500"
                      }, [
                        _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                      ], 8, _hoisted_13))
                ])
              ]))
            }), 128)),
        (showChampionDeleteNotification.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass({
              'rounded-md p-4 mt-5': true,
              'bg-green-50': deleteChampSuccess.value,
              'bg-red-50': !deleteChampSuccess.value,
              })
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(deleteChampSuccess.value ? _ctx.CheckCircleIcon : _ctx.ExclamationCircleIcon), {
                    class: _normalizeClass({
                  'h-5 w-5': true,
                  'text-green-400': deleteChampSuccess.value,
                  'text-red-400': !deleteChampSuccess.value,
                }),
                    "aria-hidden": "true"
                  }, null, 8, ["class"]))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", {
                    class: _normalizeClass({
                  'text-sm font-medium': true,
                  'text-green-800': deleteChampSuccess.value,
                  'text-red-800': !deleteChampSuccess.value,
                })
                  }, _toDisplayString(deleteChampSuccess.value
                  ? _ctx.$t("internal_view.delete_champion_success")
                  : _ctx.$t("internal_view.delete_champion_error")), 3)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass({
                  'inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2': true,
                  'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-green-600 focus:ring-offset-green-50':
                    deleteChampSuccess.value,
                  'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50':
                    !deleteChampSuccess.value,
                  }),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showChampionDeleteNotification.value = false))
                    }, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(
                    deleteChampSuccess.value
                    ? "internal_tools.success.btnClose"
                    : "internal_tools.error.btnClose"
                  )), 1),
                      _createVNode(_unref(XMarkIcon), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ], 2)
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newSchoolGroupAdmins.value, (admin, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: admin._id,
            class: "columns-5 mt-4 mb-2 relative"
          }, [
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_name'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_name'),
              modelValue: admin.firstName,
              "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
              style: { position: 'relative' },
              validation: "required",
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_surname'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_surname'),
              modelValue: admin.lastName,
              "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
              style: { position: 'relative' },
              validation: "required",
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "email",
              label: _ctx.$t('internal_tools.form.champion_email'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_email'),
              modelValue: admin.email,
              "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
              validation: "required|email|(500)email_exists",
              style: { position: 'relative' },
              "validation-rules": { email_exists: email_exists },
              "validation-messages": {
                    email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                    ),
                    email: _ctx.$t(
                    'add_grades_class_component.step_1.invalid_email'
                    )
                },
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_title'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_title'),
              readonly: "",
              style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
              modelValue: admin.designation,
              "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: _ctx.$t('internal_tools.form.champion_phone'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_phone'),
              modelValue: admin.phoneNumber,
              "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: ($event: any) => (removeSchoolGroupChampion(index)),
                class: "mt-2 text-red-500"
              }, [
                _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
              ], 8, _hoisted_21)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-[#475467]",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (addSchoolGroupChampion()), ["prevent"]))
          }, [
            _hoisted_23,
            _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
          ]),
          _createElementVNode("button", {
            class: _normalizeClass([
                            'px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg',
                            isButtonDisabled.value && !hasChanges.value ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                        ]),
            onClick: saveChanges,
            disabled: isButtonDisabled.value && !hasChanges.value
          }, [
            _createElementVNode("h1", _hoisted_26, [
              (
                        _unref(adminStore).loader.creatingAdmin == true ||
                        _unref(schoolGroupStore).loader.schoolGroupUpdate == true
                    )
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                    _createVNode(_component_spinner_loader, { color: 'text-white' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
            ])
          ], 10, _hoisted_25)
        ]),
        (updateSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_CheckCircleIcon, {
                    class: "h-5 w-5 text-green-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("p", {
                    class: "text-sm font-medium text-green-800",
                    innerHTML: responseMessage.value
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50",
                      onClick: closeSuccess
                    }, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("internal_tools.success.btnClose")), 1),
                      _createVNode(_unref(XMarkIcon), {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: confirmChampionDeletionModal.value,
      onLocalModalOpen: _cache[6] || (_cache[6] = ($event: any) => (confirmChampionDeletionModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_unref(TrashIcon), { class: "h-6 w-6" })
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_DialogTitle, {
              as: "h3",
              class: "text-lg font-semibold text-[##101828] mb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t("internal_tools.school_group.confirm_text")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: canceldeletion
            }, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.back")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (adminToDelete.value && removeExistingChampion(adminToDelete.value, $event)))
            }, [
              _createElementVNode("div", _hoisted_44, [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_btn")) + " ", 1),
                (_unref(adminStore).loader.deleteAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(_component_spinner_loader)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})